import MyEventsContextMenu from "./MyEventsContextMenu"
import MyEventsSortListing from "./MyEventsSortListing"


document.addEventListener("DOMContentLoaded", function () {

    let elContextMenus = document.querySelectorAll(".my-events__item-context-menu");

    if (elContextMenus.length) {
        
        elContextMenus.forEach(elContextMenu => new MyEventsContextMenu(elContextMenu));

    }

    let elSortListing = document.querySelector(".my-events__utility-sort");

    if (elSortListing) {

        new MyEventsSortListing(elSortListing);

    }

});